import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'team-autocomplete';

export function useTeamAutocompleteQuery({
	fragment = '',
	pageSize = 50,
	enforcePageSize = true,
	enabled = true,
}: {
	fragment?: string;
	pageSize?: number;
	enforcePageSize?: boolean;
	enabled?: boolean;
} = {}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: async () => {
			const url = Api.ImpersonationBroker.composeApiUrl({
				queryParams: { fragment, pageSize, enforcePageSize },
				urlPath: 'LeadServed/team/autocomplete',
			});

			const result = await userSession.webServiceHelper.callAsync<{ values: string[] }>(url, 'GET');
			return result.values || [];
		},
		queryKey: [BASE_QUERY_KEY, userSession.account?.id, fragment, pageSize, enforcePageSize],
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
